import { Box, MenuItem, TextField } from '@mui/material';
import React from 'react';
import { useDirection } from '../../context/DirectionContext';
import { translate as tr } from '../../i18n/translations';
import { SharedParameter, StatementTone } from '../../types/api';
import ParameterPicker from '../Parameters/ParameterPicker';

export const TONES: StatementTone[] = ['positive', 'negative', 'neutral'];

const toneStyle: Record<StatementTone, { mark: string; color: string; bg: string }> = {
  positive: { mark: '+', color: '#047857', bg: '#D1FAE5' },
  negative: { mark: '−', color: '#B91C1C', bg: '#FEE2E2' },
  neutral:  { mark: '•', color: '#475569', bg: '#F1F5F9' },
};

export const ToneMark: React.FC<{ tone: StatementTone }> = ({ tone }) => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      width: 22, height: 22, borderRadius: '50%', flexShrink: 0,
      fontWeight: 700, color: toneStyle[tone].color, bgcolor: toneStyle[tone].bg,
    }}
  >
    {toneStyle[tone].mark}
  </Box>
);

export const ToneSelect: React.FC<{ value: StatementTone; onChange: (tone: StatementTone) => void; label?: string }> = ({
  value, onChange, label,
}) => {
  const { lang } = useDirection();
  return (
    <TextField
      select
      size="small"
      label={label}
      value={value}
      onChange={e => onChange(e.target.value as StatementTone)}
      sx={{ minWidth: 120 }}
    >
      {TONES.map(t => <MenuItem key={t} value={t}>{tr(`tone.${t}`, lang)}</MenuItem>)}
    </TextField>
  );
};

/** Optional parameter link, picked from the unit's bank (P5); clearing it unlinks the statement. */
export const ParameterSelect: React.FC<{
  value: string | null;
  options: SharedParameter[];
  onChange: (id: string | null) => void;
}> = ({ value, options, onChange }) => {
  const { lang } = useDirection();
  return (
    <Box sx={{ minWidth: 200 }}>
      <ParameterPicker label={tr('stmt.parameter', lang)} value={value} options={options} onChange={p => onChange(p?.id ?? null)} />
    </Box>
  );
};
